/* eslint-ignore */
// @ts-nocheck
import React, { useCallback, useState, useEffect } from 'react';
import { toast } from 'react-toastify';


import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import {
  getCustomerAddress,
  postUserCustomer,
} from 'services/firstAccessServices';

import { useFirstAccess } from '../../../../../hooks/useFirstAccess';

import {
  formatDocumentForDisplay,
  normalizeDocumentForPayload,
  sanitizeDocument,
  validateDocument,
} from '~/utils/document';

import {
  Container,
  Title,
  Text,
  FormContainer,
  IconCodCond,
  IconDoc,
  InputCond,
  InputDoc,
  WrapSearchDocument,
  SearchDocumentText,
  SearchDocumentIcon,
  CheckBoxWrap,
  CheckBox,
  CheckBoxText,
  CheckBoxTextHighlight,
  ButtonNext,
  ButtonBack,
  ButtonText,
  ButtonsWrap,
  AddressWrap,
  AddressSelect,
  AddressSelected,
  AddressText,
  NameAddressWrap,
  CorporateName,
  ContainerAddress,
  WrapSearchDocumentContent,
} from './styles';
import InputSearch from './InputSearch';

function YourIdentification({ activeStep, setActiveStep, setShowModal }) {
  const {
    codCond,
    handleSetCodCond,
    document,
    handleSetDocument,
    checkPrivacyPolicy,
    handleSetCheckPrivacyPolicy,
    siteId,
    handleSetSiteId,
    handleSetUserId,
    address,
    handleSetAddress,
    corporateName,
    handleSetCorporateName,
  } = useFirstAccess();

  const [errorCond, setErrorCond] = useState('');
  const [errorDoc, setErrorDoc] = useState('');
  const [showAddress, setShowAddress] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [orderAddress, setOrderAddres] = useState([]);
  const [adressesFiltered, setAdressesFiltered] = useState([]);

  useEffect(() => {
    setShowAddress(address?.length > 0);
  }, [address, showAddress]);

  useEffect(() => {
    if (address?.length > 0) {
      address.sort((a, b) => {
        if (a.addressLine > b.addressLine) {
          return 1;
        }
        if (a.addressLine < b.addressLine) {
          return -1;
        }
        return 0;
      });
      setOrderAddres(address);
    }
  }, [address]);

  useEffect(() => {
    if (searchValue.length > 0 && orderAddress.length > 0) {
      const searchTitle = orderAddress.filter((addressItem) =>
        addressItem?.addressLine?.toLowerCase()?.includes(
          searchValue
            ?.normalize('NFD')
            ?.replace(/[\u0300-\u036f]/g, '')
            ?.toLowerCase()
        )
      );

      const searchCity = orderAddress.filter((addressItem) =>
        addressItem?.city?.toLowerCase()?.includes(
          searchValue
            ?.normalize('NFD')
            ?.replace(/[\u0300-\u036f]/g, '')
            ?.toLowerCase()
        )
      );

      const searchNumber = orderAddress.filter((addressItem) =>
        addressItem?.addressNumber?.toLowerCase()?.includes(
          searchValue
            ?.normalize('NFD')
            ?.replace(/[\u0300-\u036f]/g, '')
            ?.toLowerCase()
        )
      );

      const searchComplement = orderAddress.filter((addressItem) =>
        addressItem?.complement?.toLowerCase()?.includes(
          searchValue
            ?.normalize('NFD')
            ?.replace(/[\u0300-\u036f]/g, '')
            ?.toLowerCase()
        )
      );

      const isEqualName = corporateName?.toLowerCase()?.includes(
        searchValue
          ?.normalize('NFD')
          ?.replace(/[\u0300-\u036f]/g, '')
          ?.toLowerCase()
      );

      if (isEqualName) {
        setAdressesFiltered(orderAddress);
      } else {
        const array = [
          ...searchTitle,
          ...searchCity,
          ...searchNumber,
          ...searchComplement,
        ];
        setAdressesFiltered([...new Set(array)]);
      }
    } else {
      setAdressesFiltered(orderAddress);
    }
  }, [searchValue, orderAddress]);

  const handleDocument = useCallback((event) => {
    handleSetDocument(sanitizeDocument(event.target.value));
    setErrorDoc(validateDocument(event.target.value));
  }, []);

  const onBlur = () => {
    handleSetDocument(formatDocumentForDisplay(document));
    setErrorDoc(validateDocument(document));
  };

  const onFocus = () => {
    handleSetDocument(sanitizeDocument(document));
  };

  const handleUser = useCallback((event) => {
    const numbers = event.target.value.replace(/[^\d]/g, '');
    event.target.value = event.target.value.replace(/[^\d]/g, '');
    if (numbers.length <= 30) {
      event.target.value = numbers;
      handleSetCodCond(event.target.value);
    }
    setErrorCond(numbers.length === 0 ? 'Campo obrigatório' : '');
  }, []);

  const handleNextStepClick = useCallback(async () => {
    const documentParam = normalizeDocumentForPayload(document);

    if (!codCond) {
      setErrorCond('Campo obrigatório');
    }

    if (!document) {
      setErrorDoc('Campo obrigatório');
    }

    if (
      !showAddress &&
      codCond &&
      document &&
      checkPrivacyPolicy &&
      !errorCond &&
      !errorDoc
    ) {
      try {
        const responseAddress = await getCustomerAddress(
          documentParam,
          codCond
        );

        if (responseAddress.length === 0)
          throw new Error(
            'Nenhum cliente encontrado. Verifique os dados digitados e tente novamente.'
          );

        const [costumerData] = responseAddress;
        handleSetCorporateName(costumerData.corporateName);

        if (!costumerData)
          throw new Error(
            'Nenhum cliente encontrado. Verifique os dados digitados e tente novamente.'
          );

        const customerAddresses = costumerData.customerAddresses.filter(
          (addressFilter) => addressFilter.addressType === 'SHIP_TO'
        );

        if (customerAddresses.length >= 2) {
          setShowAddress(true);
          handleSetAddress(customerAddresses);
        } else {
          const [costumerFirstAddress] = customerAddresses;
          const { siteId: sitIdResponse } = costumerFirstAddress;

          if (sitIdResponse) {
            handleSetSiteId(sitIdResponse);
            const userIdResponse = await postUserCustomer(
              documentParam,
              codCond,
              sitIdResponse,
              checkPrivacyPolicy
            );
            handleSetUserId(userIdResponse);
            setActiveStep(activeStep + 1);
          } else {
            toast.error('Não conseguimos identificar seu endereço!');
          }
        }
      } catch (err) {
        toast.error(err.message);
      }
    }
    if (showAddress && siteId) {
      const userIdResponse = await postUserCustomer(
        documentParam,
        codCond,
        siteId,
        checkPrivacyPolicy
      );
      handleSetUserId(userIdResponse);
      setActiveStep(activeStep + 1);
    }
  }, [
    codCond,
    document,
    checkPrivacyPolicy,
    errorCond,
    errorDoc,
    siteId,
    showAddress,
  ]);

  const handleClickBack = useCallback(() => {
    if (!showAddress) return (window.location.href = '/');
    handleSetAddress([]);
    setShowAddress(false);
  }, [address, showAddress]);

  const changeValue = (value) => {
    setSearchValue(value);
  };

  return (
    <Container>
      <Title>
        {!showAddress && 'Identificação'}
        {showAddress && 'Identificação - Endereços encontrados'}
      </Title>
      <Text>
        {!showAddress &&
          'Olá! Boas-vindas à você que chegou para somar energias. Siga o passo a passo para se cadastrar no Minha Ultragaz.'}
        {showAddress &&
          'Encontramos os seguintes endereços vinculados ao código fornecido. Qual deseja cadastrar?'}
      </Text>
      <FormContainer>
        <>
          {showAddress && (
            <InputSearch
              searchValue={searchValue}
              setSearchValue={(e) => changeValue(e)}
            />
          )}
          {showAddress && (
            <ContainerAddress>
              {adressesFiltered.map((addr) => (
                <AddressWrap onClick={() => handleSetSiteId(addr.siteId)}>
                  <AddressSelect isSelected={siteId === addr.siteId}>
                    {siteId === addr.siteId && <AddressSelected />}
                  </AddressSelect>
                  <NameAddressWrap>
                    <CorporateName>{corporateName}</CorporateName>
                    <AddressText>
                      {`${addr.addressLine}, ${addr.addressNumber}
                      ${addr.complement ? ' - ' : ''}
                      ${(addr.complement || '')
                        .toLowerCase()
                        .replace(/(?:^|\s)\S/g, function (a) {
                          return a.toUpperCase();
                        })}
                      - ${addr.city}`}
                    </AddressText>
                  </NameAddressWrap>
                </AddressWrap>
              ))}
            </ContainerAddress>
          )}
          {!showAddress && (
            <>
              <InputCond
                labelText="Digite o código do cliente"
                inputType="text"
                inputName="codCond"
                inputId="codCond"
                value={codCond}
                maxValue={30}
                onChange={(e) => handleUser(e)}
                icon={IconCodCond}
                msgError={errorCond}
              />
              <WrapSearchDocument>
                <WrapSearchDocumentContent onClick={() => setShowModal(true)}>
                  <SearchDocumentText>
                    Como encontrar o código
                  </SearchDocumentText>
                  <SearchDocumentIcon>i</SearchDocumentIcon>
                </WrapSearchDocumentContent>
              </WrapSearchDocument>
              <InputDoc
                labelText="Insira o CPF ou CNPJ"
                inputType="text"
                inputName="doc"
                inputId="doc"
                value={document}
                onChange={(e) => handleDocument(e)}
                onBlur={() => onBlur()}
                onFocus={() => onFocus()}
                icon={IconDoc}
                msgError={errorDoc}
              />
              <CheckBoxWrap>
                <CheckBox
                  isChecked={checkPrivacyPolicy}
                  setIsChecked={handleSetCheckPrivacyPolicy}
                />
                <CheckBoxText>Li e aceito as regras da</CheckBoxText>
                <CheckBoxTextHighlight
                  href="https://www.ultragaz.com.br/institucional/politica-de-privacidade"
                  target="_blank"
                >
                  Política de privacidade
                </CheckBoxTextHighlight>
              </CheckBoxWrap>
            </>
          )}
        </>
        <ButtonsWrap>
          <ButtonNext
            buttonType={!checkPrivacyPolicy ? 'disabled' : 'primary'}
            disabled={!checkPrivacyPolicy}
            iconRight={AiOutlineArrowRight}
            onClick={handleNextStepClick}
          >
            Continuar
          </ButtonNext>
          <ButtonBack
            buttonType="outline"
            iconLeft={AiOutlineArrowLeft}
            onClick={handleClickBack}
          >
            <ButtonText>Voltar</ButtonText>
          </ButtonBack>
        </ButtonsWrap>
      </FormContainer>
    </Container>
  );
}

export default YourIdentification;
